import axios from "axios";
import { API_BASE_URL } from "../../config";
import { APP_TOKEN_KEY } from "../redux/appAuthSlice";
import {
  normalizePhoneInput,
  resolvePaymentUserId,
} from "../utils/paymentHelpers";

const intouchPayApi = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

intouchPayApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(APP_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const buildPaymentPayload = ({ userId, amount, phoneNumber, paymentMethod, password }) => {
  const payload = {
    userId: resolvePaymentUserId(userId),
    amount: Math.round(Number(amount)),
    phoneNumber: normalizePhoneInput(phoneNumber),
    paymentMethod: paymentMethod || "MTN",
  };

  if (password != null && password !== "") {
    payload.password = password;
  }

  return payload;
};

export async function createIntouchPayDeposit({ userId, amount, phoneNumber, paymentMethod }) {
  const { data } = await intouchPayApi.post(
    "/api/intouchpay/collection",
    buildPaymentPayload({ userId, amount, phoneNumber, paymentMethod })
  );
  return data;
}

export async function createIntouchPayWithdrawal({
  userId,
  amount,
  phoneNumber,
  paymentMethod,
  password,
}) {
  const { data } = await intouchPayApi.post(
    "/api/intouchpay/payout",
    buildPaymentPayload({ userId, amount, phoneNumber, paymentMethod, password })
  );
  return data;
}
